if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.boundSubmitHandler = this.onSubmitHandler.bind(this);
      }

      connectedCallback() {
        this.form?.removeEventListener('submit', this.boundSubmitHandler);
        this.form = this.querySelector('form');
        const variant = this.form?.querySelector('[name=id]');
        if (!variant) return;
        variant.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.sectionStatus = this.getAttribute('section-status')
        this.purchaseLimit = this.getAttribute('purchase-limit')
        this.quantity = this.getQuantityInput();
        this.productFormquantity = this.querySelector('[name="quantity"]')
        this.hideErrors = this.dataset.hideErrors === 'true';
        // App/payment-only forms retain their native handler.
        if (!this.submitButton) return;
        if (document.querySelector('cart-drawer') && !this.hasAttribute('data-bw-cart-first')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.form.addEventListener('submit', this.boundSubmitHandler);
      }

      getQuantityInput() {
        const local = this.closest('.product-form__quantity')?.querySelector('.quantity__input.prdct_pg');
        if (local) return local;
        const associated = Array.from(this.form?.elements || []).filter((input) => input.name === 'quantity');
        return associated.find((input) => input.type !== 'hidden' && !input.classList.contains('hidden')) || associated[0] || null;
      }

      themeDefaultSubmission(formData){
        //  theme default code
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.hasAttribute('data-bw-cart-first') || !this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
        // Theme default code end 
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.disabled || this.submitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.quantity = this.getQuantityInput();
        const quantity = this.quantity ? Number(this.quantity.value) : 1;
        if (!Number.isSafeInteger(quantity) || quantity < 1 || (this.quantity && !this.quantity.checkValidity())) {
          this.quantity?.reportValidity();
          const limitMessage = this.quantity?.validity.rangeOverflow && window.cartStrings.quantityError
            ? window.cartStrings.quantityError.replace('[quantity]', this.quantity.max)
            : this.quantity?.validationMessage || window.cartStrings.error;
          this.handleErrorMessage(limitMessage);
          return;
        }
        if (this.productFormquantity) this.productFormquantity.value = String(quantity);
        // Snapshot the US deposit plan, variant, quantity and properties together,
        // before the asynchronous cart read. The existing deposit validator stays authoritative.
        const formData = new FormData(this.form);
        formData.set('quantity', String(quantity));
        if (this.hasAttribute('data-bw-deposit-product')) {
          try {
            if (!window.bwBossborotDeposit) throw new Error('The deposit option is not ready. Please wait for it to load.');
            window.bwBossborotDeposit.prepareCart(this, formData);
          } catch (error) {
            this.handleErrorMessage(error.message);
            return;
          }
        }
        if (this.dataset.bwPlanSelectionUrl) {
          window.location.assign(this.dataset.bwPlanSelectionUrl);
          return;
        }
        const productId = formData.get('id');
        if (!productId) return;
        this.submitting = true;
        try {
          await window.bwCartGuard.run(async () => {
            const cart = await window.bwCartGuard.read();
            if (cart.items.length > 0 && this.sectionStatus === 'ON' && cart.items.some(item => String(item.id) !== String(productId))) {
              this.showRestriction('[pre-order-popup]');
              return;
            }
            const limit = window.bwCartGuard.positiveLimit(this.purchaseLimit);
            const existing = window.bwCartGuard.productQuantity(cart, this.dataset.bwProductId, productId);
            if (existing + Number(formData.get('quantity')) > limit) {
              window.bwCartGuard.warn();
              return;
            }
            await this.themeDefaultSubmission(formData);
          });
        } catch (error) {
          console.error(error);
          this.handleErrorMessage(window.cartStrings.error);
        } finally {
          this.submitting = false;
        }
      }

      showRestriction(selector) {
        const popup = document.querySelector(selector);
        if (popup) popup.style.display = 'block';
        else this.handleErrorMessage(window.cartStrings.error);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper && errorMessage) {
          this.errorMessageWrapper = document.createElement('div');
          this.errorMessageWrapper.className = 'bw-quick-add-error';
          this.errorMessageWrapper.setAttribute('role', 'alert');
          this.errorMessage = document.createElement('span');
          this.errorMessage.className = 'product-form__error-message';
          this.errorMessageWrapper.append(this.errorMessage);
          this.append(this.errorMessageWrapper);
        }
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (!errorMessage) this.errorMessageWrapper.style.removeProperty('display');

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          // Pdp message error popup 
          this.errorMessageWrapper.style.display = 'flex';
        }
      }
    }
  );
}
